export default "__VITE_ASSET__a2abc444__"